import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { rangePreset } from "@/lib/utils-app";
import { CalendarBlank } from "@phosphor-icons/react";

const PRESETS = [
  { key: "today", label: "Today" },
  { key: "week", label: "Week" },
  { key: "month", label: "Month" },
  { key: "quarter", label: "Quarter" },
  { key: "year", label: "Year" },
  { key: "all", label: "All" },
];

export default function DateRangeBar({ range, setRange }) {
  const setPreset = (k) => setRange({ preset: k, ...rangePreset(k) });
  const setCustomStart = (v) => setRange({ ...range, preset: "custom", start: v || null });
  const setCustomEnd = (v) => setRange({ ...range, preset: "custom", end: v || null });

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-3 md:p-4" data-testid="date-range-bar">
      <div className="flex items-center gap-2 flex-wrap">
        <CalendarBlank size={18} className="text-slate-500" />
        <div className="flex gap-1 flex-wrap">
          {PRESETS.map((p) => (
            <button
              key={p.key}
              onClick={() => setPreset(p.key)}
              data-testid={`range-preset-${p.key}`}
              className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${
                range.preset === p.key
                  ? "bg-emerald-800 text-white"
                  : "bg-slate-100 text-slate-700 hover:bg-slate-200"
              }`}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 mt-3">
        <div>
          <Label className="text-xs text-slate-500">From</Label>
          <Input
            type="date"
            value={range.start || ""}
            onChange={(e) => setCustomStart(e.target.value)}
            className="mt-1 h-9"
            data-testid="range-start-input"
          />
        </div>
        <div>
          <Label className="text-xs text-slate-500">To</Label>
          <Input
            type="date"
            value={range.end || ""}
            onChange={(e) => setCustomEnd(e.target.value)}
            className="mt-1 h-9"
            data-testid="range-end-input"
          />
        </div>
      </div>
    </div>
  );
}
